
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/contexts/AuthContext";
import { ChangePasswordDialog } from "@/components/auth/ChangePasswordDialog";
import { Settings, LogOut, ChevronDown } from "lucide-react";

export function UserMenu() {
  const { currentUser, signOut } = useAuth();
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error("Sign out error:", error);
    }
  };

  if (!currentUser) return null;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="flex items-center gap-3 text-gray-700 hover:bg-gray-100 p-3"
          >
            <div className="w-8 h-8 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 flex items-center justify-center text-white font-semibold text-sm">
              {currentUser.email?.[0]?.toUpperCase() || 'U'}
            </div>
            <div className="flex-1 truncate text-left">
              <p className="font-medium truncate text-sm">{currentUser.email}</p>
            </div>
            <ChevronDown className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent 
          align="end" 
          className="w-56 bg-gray-50 border border-gray-300 shadow-lg z-50"
        >
          <DropdownMenuItem
            onClick={() => setChangePasswordOpen(true)}
            className="flex items-center gap-2 cursor-pointer hover:bg-gray-200 text-gray-800"
          >
            <Settings className="h-4 w-4" />
            Change Password
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={handleSignOut}
            className="flex items-center gap-2 cursor-pointer hover:bg-gray-200 text-red-600"
          >
            <LogOut className="h-4 w-4" />
            Sign Out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <ChangePasswordDialog open={changePasswordOpen} onOpenChange={setChangePasswordOpen} />
    </>
  );
}
